const ENRisks = {
	"aberto": "open",
	"abertos": "open",
	"Aberto": "Open",
	"Aceitar":"Accept",
	"ação": "action",
	"Ações": "Actions",
	"Adicione uma ação ao plano de contingência": "Add an action to the contingency plan",
	"Adicionar plano de ação": "Add action plan",
	"Adicionar análise": "Add analysis",
	"Adicionar análise de": "Add analysis of",
	"Adicionar plano de contigência": "Add contingency plan",
	"Adicionar risco": "Add risk",
	"Alterar risco": "Change risk",
	"Alterar análise": "Change analysis",
	"Alteração permitida apenas na análise de risco": "Change allowed only in risk analysis",
	"Alto":"High",
	"Análise":"Analysis",
	"Análises": "Analysis",
	"análise": "analysis",
	"análises": "analysis",
	"Análise adicionada com sucesso":"Analysis successfully added",
	"Análise alterada com sucesso": "Analysis successfully changed",
	"Análise de Risco excluída com sucesso": "Risk Analysis successfully deleted",
	"Ameaça": "Threat",
	"ameaça": "threat",
	"ameaças": "threats",
	"Após salvar a Análise, será liberada a opção 'Ações' onde você poderá adicionar/editar as ações desta Análise.": "After saving the Analysis, the option 'Actions' will be released where you can add/edit the actions of this Analysis.",
	"Baixo":"Low",
	"Cadastro de risco": "Registration of risk",
	"Criar novo risco de classificação":"Create new risk classification",
	"cancelados" : "Canceled",
	"cancelado" : "canceled",
	"Cancelado":"Canceled",
	"Classificação de risco": "Risk classification",
	"Como": "How",
	"Como é requerido": "How is required",
	"Compartilhar": "Share",
	"Data Inicial é requerida": "Initial date is required",
	"Dias é requerido":"Days is required",
	"Dias para ação ser concluída": "Days for action to be completed",
	"Descrição do impacto":"Impact description",
	"Descrição do risco": "Risk description",
	"Digite o título do risco para excluí-lo": "Enter the title of risk to delete",
	"Disparar plano de contingência": "Trigger contingency plan",
	"Deseja realmente excluir o risco": "Do you really want to delete the risk",
	"Deseja realmente reabrir o risco": "Do you really want to reopen the risk",
	"Deseja realmente excluir a Análise de Risco": "Do you really want to delete Risk Analysis",
	"Deletar risco":"Delete risk",
	"Deletar plano de contigência": "Delete contingency plan",
	"Deletar plano de ação": "Delete action plan",
	"Data da incidência":"Incidence date",
	"Erro ao adicionar risco": "Error adding risk",
	"Erro ao adicionar análise": "Error adding analysis",
	"Erro ao alterar risco": "Error on changing risk",
	"Erro ao carregar ações": "Error on loading actions",
	"Erro ao adicionar risco de classificação": "Error adding risk classification",
	"Exclusão de Risco": "Delete Risk",
	"Exclusão de Análise de Risco": "Exclusion of Risk Analysis",
	"Erro ao carregar o risco": "Error loading risk",
	"Erro ao excluir risco": "Error on deleting risk",
	"Erro ao excluir a Análise de Risco": "Error deleting Risk Analysis",
	"Erro ao adicionar ocorrência": "Error on adding occurrence",
	"Erro ao alterar ocorrência": "Error on changing occurrence",
	"Erro ao carregar os riscos": "Error on loading risks",
	"Erro ao carregar o análise de risco": "Error loading risk analysis",
	"Erro ao atualizar risco, favor atualizar a pagina": "Error updating risk, please update page",
	"Erro ao registrar incidência": "Error on register incidence",
	"Erro ao reabir risco": "Error reopening risk",
	"Esta incidência não possui nenhum plano de contigência": "This incidence does not have any contingency plan",
	"Estratégia":"Strategy",
	"Estratégia é requerida": "Strategy is required",
	"Explorar ou perseguir":"Explore or chase",
	"Finalizado":"Finished",
	"finalizado": "finalized",
	"finalizados": "finalized",
	"finalizadas": "finalized",
	"finalizada": "finalized",
	"Grau": "Degree",
	"Histórico":"Historic",
	"Histórico de risco":"Risk history",
	"Impacto":"Impact",
	"Impacto é requerido": "Impact is required",
	"Incidentes": "Incidents",
	"incidentes": "incidents",
	"Incidências": "Incidences",
	"incidente": "incident",
	"Incidência registrada com sucesso": "Incident successfully added",
	"Local":"Locale",
	"Melhorar": "Improve",
	"Muito alto":"Very high",
	"Moderado":"Moderate",
	"Muito baixo":"Very low",
	"Motivo":"Reason",
	"Meus riscos": "My risks",
	"Mitigar ou reduzir":"Mitigate or reduce",
	"Novo risco":"New risk",
	"Oportunidade": "Opportunity",
	"oportunidades": "opportunities",
	"oportunidade": "opportunity",
	"oportunidade(s)": "opportunities",
	"Ocorrência alterada com sucesso": "Occurrence successfully changed",
	"Ocorrência adicionada com sucesso": "Occurrence successfully added",
	"Probabilidade":"Probability",
	"Prevenção":"Prevention",
	"Prevenir, eliminar ou evitar":"Prevent, eliminate or avoid ",
	"Processo":"Process",
	"Planos de contigência":"Contingency plans",
	"Plano de contigência": "Contingency plan",
	"Painel de Riscos":"Risk panel",
	"Painel de riscos":"Risk panel",
	"Risco alterado com sucesso": "Risk successfully changed",
	"Risco adicionado com sucesso": "Risk successfully added",
	"Risco excluído com sucesso": "Risk successfully deleted",
	"Risco reaberto com sucesso": "Risk reopened successfully",
	"Reabrir risco": "Reopen risk",
	"Registro de incidência":"Incidence record",
	"Remover plano de contigência": "Remove contingency plan",
	"Remover ação": "Remove action",
	"Selecione um plano de contingência": "Select a contingency plan",
	"Setor do impacto": "Impact sector",
	"Setor do risco": "Risk sector",
	"Sem setor de impacto": "Without impact sector",
	"Sem setor de risco": "Without risk sector",
	"Probabilidade é requerida": "Probability is required",
	"Total de análises": "Total analysis",
	"Total de incidências": "Total incidents",
	"Todos riscos": "All risks",
	"Transferir ou terceirizar":"Transfer or outsource",
	"Titulo do risco não confere": "Risk title does not match",
	"Valor dos dias está incorreto": "Value of days is incorrect",
	"Ver cadastro completo": "See full registration",
	"Ver cadastro simplificado": "See simplified registration",
	"Quadrante": "Quadrant"
};

export default ENRisks;

